// extracted by css-extract-rspack-plugin
export default {"cls1":"ErrorStateFeed-cls1_dDl","cls2":"ErrorStateFeed-cls2_Dpr ErrorStateFeed-cls1_dDl"};